const getCookieValue = (name) => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1]
}

// https://developers.facebook.com/docs/facebook-pixel/advanced/
let initialized = false

export const metaPixelEvent = (name, options = {}, eventId = {}) => {
  if (process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID && window?.fbq) {
    if (!initialized) {
      window.fbq('init', process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID, {
        external_id: options.external_id
      })
      initialized = true
    }
    const fbc = getCookieValue('_fbc')
    const fbp = getCookieValue('_fbp')
    const url = window.location.href

    window.fbq('track', name, { ...options, fbc, fbp,  event_source_url: url }, eventId)
  }
}
